module.exports = __webpack_public_path__ + "img/backlinght.af5aeb3e.png";